'use client'

import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { Title } from '@/components/Title'
import { PushContext, PushContextType } from '@/context/PushContext'
import { checkPushInit } from '@/libs/Pushes/pushes.lib'
import styles from './PushTagList.module.scss'
import SectionTitle from '@/components/SectionTitle/SectionTitle'

export interface TagItem {
  id: string
  name: string
  selected?: boolean
}
export interface TagList {
  name: string
  tags: Array<TagItem>
}
export interface TagItemComponentProps {
  item: TagItem
  subscribedTags: Array<TagItem> | []
  setSubscribedTags: Dispatch<SetStateAction<Array<TagItem> | []>>
}

const TagItemComponent = ({ item, subscribedTags, setSubscribedTags }: TagItemComponentProps) => {
  const [checked, setChecked] = useState<boolean>(false)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    subscribedTags.some((tag: TagItem) => tag.id === item.id) ? setChecked(() => true) : setChecked(() => false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleSubscription = () => {
    if (checked) {
      globalThis.window.pushDelivery.unsubscribeFrom(item.id)
    } else {
      globalThis.window.pushDelivery.subscribeTo(item.id)
    }
    globalThis.window.pushDelivery
      .getSubscribedTags()
      .then((res: Array<TagItem>) => {
        setSubscribedTags(res)
      })
      .catch((error: Error) => {
        console.log('Tags not available', error)
      })
    setChecked((prev) => !prev)
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    // Toggle on Space and Enter key press
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault() // Prevent page scroll on space
      toggleSubscription()
    }
  }

  return (
    <label htmlFor={item.id} className={styles.container}>
      <input
        type="checkbox"
        id={item.id}
        name={item.name}
        checked={checked}
        onChange={toggleSubscription}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        aria-label={item.name}
      />
      <span className={styles.checkmark}></span>
      {item.name}
    </label>
  )
}

const WidgetPushTagList = () => {
  const [pushDeliveryReady, setPushDeliveryReady] = useState<boolean>(false) // window.pushDeliveryReady
  const [pushInitialized, setPushInitialized] = useState<boolean>(false)
  const [tagList, setTagList] = useState<Array<TagList> | []>([])
  const [subscribedTags, setSubscribedTags] = useState<Array<TagItem> | []>([])
  const pushContext = useContext(PushContext)
  const { updateIsOpen, permission, updatePermission } = pushContext as PushContextType

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin !== globalThis.window.origin) return
      if (event.data === 'pushDeliveryReady') {
        setPushDeliveryReady(() => true)
      }
    })
  }, [])

  useEffect(() => {
    if (pushDeliveryReady) {
      checkPushInit(updateIsOpen, updatePermission)
        .then(() => {
          setPushInitialized(() => true)
        })
        .catch((error: any) => {
          console.log('pushDelivery not available', error)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushDeliveryReady])

  useEffect(() => {
    if (pushInitialized && permission) {
      globalThis.window.pushDelivery
        .getTags()
        .then((res: Array<TagList>) => {
          setTagList(res)
        })
        .catch((error: Error) => {
          console.log('Tags not available', error)
        })
      globalThis.window.pushDelivery
        .getSubscribedTags()
        .then((res: Array<TagItem>) => {
          setSubscribedTags(res)
        })
        .catch((error: Error) => {
          console.log('Tags not available', error)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushInitialized])

  return (
    <section>
      <SectionTitle title="Ressorts" />
      <div className={styles['tag-list']}>
        {tagList.length > 0 &&
          tagList[0].tags.length > 0 &&
          tagList[0].tags
            .slice(0, 20)
            .map((item) => (
              <TagItemComponent
                key={item.id}
                item={item}
                subscribedTags={subscribedTags}
                setSubscribedTags={setSubscribedTags}
              />
            ))}
      </div>
    </section>
  )
}

export default WidgetPushTagList
